// Traductions EN/AR du texte descriptif des kits. Le FR reste la source (stocké en base).
export const PRODUCT_I18N = {
  'party-led-kit-50-personnes': {
    en: 'Complete LED wristband kit to light up your events for up to 50 guests. Perfect for small private parties, birthdays and intimate evenings. Wireless control included.',
    ar: 'طقم كامل من أساور LED لإضاءة فعالياتك حتى 50 ضيفاً. مثالي للحفلات الخاصة الصغيرة وأعياد الميلاد والأمسيات الحميمة. يشمل التحكم اللاسلكي.',
  },
  'party-led-kit-100-personnes': {
    en: 'The ideal solution for corporate events and weddings of up to 100 guests. Create an unforgettable light atmosphere with perfect synchronisation.',
    ar: 'الحل المثالي لفعاليات الشركات وحفلات الزفاف حتى 100 ضيف. اصنع أجواءً مضيئة لا تُنسى مع تزامن مثالي.',
  },
  'party-led-kit-200-personnes': {
    en: 'Professional kit for festivals, concerts and large events of up to 200 guests. Spectacular light effects guaranteed.',
    ar: 'طقم احترافي للمهرجانات والحفلات الموسيقية والفعاليات الكبرى حتى 200 ضيف. مؤثرات ضوئية مذهلة مضمونة.',
  },
  'party-led-kit-300-personnes': {
    en: 'Professional solution for large-scale events. Synchronised LED animation for spectacular evenings of up to 300 guests.',
    ar: 'حل احترافي للفعاليات الكبيرة. إضاءة LED متزامنة لأمسيات مذهلة حتى 300 ضيف.',
  },
  'party-led-kit-400-personnes': {
    en: 'Festival pack for major events of up to 400 guests. Performance and reliability for your biggest projects.',
    ar: 'باقة مهرجانات للفعاليات الكبرى حتى 400 ضيف. أداء وموثوقية لأكبر مشاريعك.',
  },
  'party-led-kit-500-personnes': {
    en: 'Complete solution for festivals and concerts of up to 500 guests. Cutting-edge technology for breathtaking shows.',
    ar: 'حل متكامل للمهرجانات والحفلات الموسيقية حتى 500 ضيف. تقنية متطورة لعروض خلّابة.',
  },
  'party-led-kit-600-personnes': {
    en: 'Major event pack for 600 guests. Ideal for indoor concerts and regional festivals.',
    ar: 'باقة فعاليات كبرى لـ 600 ضيف. مثالية للحفلات الموسيقية الداخلية والمهرجانات الإقليمية.',
  },
  'party-led-kit-700-personnes': {
    en: 'Premium solution for large events of up to 700 guests. Performance and spectacle guaranteed.',
    ar: 'حل متميّز للفعاليات الكبيرة حتى 700 ضيف. أداء وإبهار مضمونان.',
  },
  'party-led-kit-800-personnes': {
    en: 'Professional equipment for large festivals of up to 800 guests. Broadcast-grade technology.',
    ar: 'معدات احترافية للمهرجانات الكبرى حتى 800 ضيف. تقنية بمستوى البث التلفزيوني.',
  },
  'party-led-kit-900-personnes': {
    en: 'Elite pack for mega-events of up to 900 guests. The benchmark for demanding professionals.',
    ar: 'باقة النخبة للفعاليات الضخمة حتى 900 ضيف. المعيار للمحترفين الأكثر تطلّباً.',
  },
  'party-led-kit-1000-personnes': {
    en: 'The ultimate solution for massive events of up to 1,000 guests. Maximum performance, unforgettable spectacle.',
    ar: 'الحل الأمثل للفعاليات الضخمة حتى 1000 ضيف. أقصى أداء وإبهار لا يُنسى.',
  },
};

export const localizeDescription = (slug, fr, lang) => {
  if (lang === 'fr' || !slug) return fr;
  return PRODUCT_I18N[slug]?.[lang] || fr;
};
